import { Waveform, ArrowLeft, Phone, ShieldCheck } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

const RefundPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ background: "#0A0A0C" }}>
      <header className="relative z-10 backdrop-blur-xl bg-[#0A0A0C]/70 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-12 py-5">
          <div className="flex items-center gap-4">
            <button onClick={() => navigate("/")} className="text-white/60 hover:text-white transition-colors" data-testid="refund-back-btn">
              <ArrowLeft size={24} />
            </button>
            <div className="flex items-center gap-3">
              <Waveform size={28} weight="bold" style={{ color: "#F59E0B" }} />
              <span className="text-xl font-light tracking-tight text-white" style={{ fontFamily: "'Outfit', sans-serif" }}>Daremusics</span>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 md:px-8 lg:px-12 py-12">
        <div className="flex items-center gap-3 mb-8">
          <ShieldCheck size={32} weight="bold" style={{ color: "#F59E0B" }} />
          <h1 className="text-4xl sm:text-5xl tracking-tight font-light text-white" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Refund Policy
          </h1>
        </div>

        <div className="bg-[#141417] border border-white/5 rounded-2xl p-6 md:p-8 space-y-6" style={{ fontFamily: "'Manrope', sans-serif" }}>
          <section>
            <h3 className="text-lg text-white font-medium mb-3">1. Subscription Refunds</h3>
            <p className="text-base leading-relaxed" style={{ color: "#A1A1AA" }}>
              If you are unsatisfied with your subscription, you may request a full refund within 24 hours of purchase, provided no songs have been generated using the subscription credits.
            </p>
          </section>

          <section>
            <h3 className="text-lg text-white font-medium mb-3">2. Partial Refunds</h3>
            <p className="text-base leading-relaxed" style={{ color: "#A1A1AA" }}>
              If songs have already been generated, a partial refund may be issued based on the remaining unused song credits at our discretion.
            </p>
          </section>

          <section>
            <h3 className="text-lg text-white font-medium mb-3">3. Subscription Expiry</h3>
            <p className="text-base leading-relaxed" style={{ color: "#A1A1AA" }}>
              All subscription plans are valid for 7 days from the date of purchase. Unused song credits will expire after 7 days and cannot be carried forward or refunded.
            </p>
          </section>

          <section>
            <h3 className="text-lg text-white font-medium mb-3">4. Technical Issues</h3>
            <p className="text-base leading-relaxed" style={{ color: "#A1A1AA" }}>
              If you experience technical issues that prevent song generation during your active subscription period, please contact our support team. We will either resolve the issue or provide appropriate compensation.
            </p>
          </section>

          <section>
            <h3 className="text-lg text-white font-medium mb-3">5. How to Request a Refund</h3>
            <p className="text-base leading-relaxed" style={{ color: "#A1A1AA" }}>
              To request a refund, contact our customer support team with your registered email address and transaction details.
            </p>
          </section>

          <section>
            <h3 className="text-lg text-white font-medium mb-3">6. Non-Refundable Cases</h3>
            <ul className="space-y-2" style={{ color: "#A1A1AA" }}>
              <li className="flex items-start gap-2 text-base leading-relaxed">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#F59E0B] shrink-0" />
                Subscriptions where all song credits have been used
              </li>
              <li className="flex items-start gap-2 text-base leading-relaxed">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#F59E0B] shrink-0" />
                Refund requests made after 7 days of purchase
              </li>
              <li className="flex items-start gap-2 text-base leading-relaxed">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#F59E0B] shrink-0" />
                Expired subscriptions
              </li>
            </ul>
          </section>

          <div className="border-t border-white/10 pt-6">
            <div className="flex items-center gap-2 mb-3">
              <Phone size={20} weight="bold" style={{ color: "#F59E0B" }} />
              <span className="text-xs uppercase tracking-[0.2em] font-bold" style={{ color: "#F59E0B" }}>Customer Support</span>
            </div>
            <div className="flex gap-6">
              <a href="tel:9493926054" className="text-white hover:text-[#F59E0B] transition-colors">9493926054</a>
              <a href="tel:9493924588" className="text-white hover:text-[#F59E0B] transition-colors">9493924588</a>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default RefundPolicyPage;
